import { isOfflineMode } from '@atlaskit/editor-common/connectivity/isOfflineMode';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../../aiPluginType';

export const getIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean =>
	isOfflineMode(api?.connectivity?.sharedState?.currentState()?.mode);

export const useIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean => {
	const { isOffline } = useSharedPluginStateWithSelector(
		api,
		['connectivity'],
		({ connectivityState }) => ({
			isOffline: isOfflineMode(connectivityState?.mode),
		}),
	);

	return isOffline;
};
